export default "__VITE_ASSET__Dbf9vLG___"